<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import FormCreator from '../UI/Form/FormCreator.vue'

export default {
  components: { FormCreator, FieldCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    financeId: { type: Number, required: true },
    commissionId: { type: Number, default: null, required: false },
    method: { type: String, required: false },
    idModalPage: { type: String, default: '' },
  },

  data() {
    return {
      def: {},
      commission: {},
      params: {},
      sending: false,
      loading: false,
      loadForm: false,
      loadField: false,
      modalName: null,
      isGift: false,
      formData: null,
    }
  },

  computed: {
    modalId() {
      if (this.method != 'delete') {
        if (this.commissionId) {
          return (this.modalName = this.commissionId)
        }

        return (this.modalName = this.financeId)
      }

      return 'delete' + this.financeId
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    //permet de générer les fields creator
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.def = def
      this.commission = obj
    },
    isSending(bool) {
      this.sending = bool
    },
    isChecked(bool) {
      this.isGift = bool
    },
    showForm() {
      if (this.commissionId) {
        this.params = { financeId: this.financeId, id: this.commissionId }
      } else {
        this.params = { financeId: this.financeId }
      }

      this.loadForm = true
    },
    openModal() {
      $('#commission-' + this.modalName).modal('show')
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      $('#commission-' + this.modalName).modal('hide')
    },
    setDatas(json) {
      this.$emit('commissions-sent', { json: json, method: this.method })
      this.closeModal()
    },
    getAmount(val) {
      if (this.commission.equipmentAmount) {
        let amount = this.$root.getNumber(val)
        let percent = this.$root.getRoundFloat((amount / this.commission.equipmentAmount) * 100, 1, 100)

        this.commission.percent = percent
      }
    },
    getPercent(val) {
      if (this.commission.equipmentAmount) {
        let percent = this.$root.getNumber(val)
        let amount = this.$root.getRoundFloat(this.commission.equipmentAmount, percent / 100, 100)

        this.commission.amount = amount
      }
    },
  },

  mounted() {
    $('#commission-' + this.modalName).on('hidden.bs.modal', () => {
      this.closeModal()
    })
  },
}
</script>
<template>
  <div class="commission-form">
    <a class="cursor-pointer" role="button" @click="showForm">
      <i v-if="method == 'post'" class="fa fa-plus" e2e-button="commissionAdd" />
      <i v-else-if="method == 'patch'" class="fa fa-edit" e2e-button="commissionUpdate" />
      <i v-else class="fas fa-trash" e2e-button="commissionDelete" />
    </a>

    <ModalDialog
      :id-modal-page="idModalPage"
      :id="'commission-' + modalId"
      class-modal-dialog="modal-xl"
      e2e-modal="commission"
    >
      <div class="d-flex justify-content-center align-items-center flex-fill" v-if="loading">
        <div class="spinner-border" style="width: 5rem; height: 5rem" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-else></div>

      <FieldCreator
        :form-data="formData"
        v-if="loadField"
        name="entity"
        form-ref="myformcommission"
        domain="commission"
        :label-top="true"
      ></FieldCreator>
      <div class="row">
        <div class="col-md-5">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="amount"
            form-ref="myformcommission"
            domain="commission"
            :label-top="true"
            @get-input-change="getAmount"
          ></FieldCreator>
        </div>
        <div class="col-md-2 font-weight-bold d-flex justify-content-center align-items-center">ou</div>
        <div class="col-md-5">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="percent"
            form-ref="myformcommission"
            domain="commission"
            :label-top="true"
            @get-input-change="getPercent"
          ></FieldCreator>
        </div>
      </div>
      <FieldCreator
        :form-data="formData"
        v-if="loadField"
        name="withProfitability"
        form-ref="myformcommission"
        domain="commission"
        :label-left="true"
      ></FieldCreator>
      <FieldCreator
        :form-data="formData"
        v-if="loadField"
        name="gift"
        form-ref="myformcommission"
        domain="commission"
        :label-left="true"
        @checked="isChecked"
      ></FieldCreator>
      <div v-if="isGift" class="row">
        <div class="col">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="giftEntity"
            form-ref="myformcommission"
            domain="commission"
            :label-top="true"
          ></FieldCreator>
        </div>
        <div class="col">
          <FieldCreator
            :form-data="formData"
            v-if="loadField"
            name="salesman"
            form-ref="myformcommission"
            domain="commission"
            :label-top="true"
          ></FieldCreator>
        </div>
      </div>

      <div class="mt-3">
        <FormCreator
          @update-data="updateData"
          v-if="loadForm"
          ref="myformcommission"
          endpoint="commissions"
          :id="commissionId"
          :method="method"
          :params="params"
          :in-modal="true"
          class-to-add="btn-lg"
          @modal-build="openModal"
          @form-build="setBuild"
          @element-build="setElement"
          @form-return="setDatas"
          @is-sending="isSending"
        >
          <div v-if="sending" class="text-center">
            <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else e2e-button="commissionSend">
            {{ $t('commission.send') }}
          </div>
        </FormCreator>

        <button type="button" class="btn btn-lg btn-secondary" @click="closeModal" e2e-button="close">
          {{ $t('main.close') }}
        </button>
      </div>
    </ModalDialog>
  </div>
</template>
